export default __webpack_public_path__ + "static/media/05.71e8771d.jpg";